import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.902 5H3.81L2.217 8.275c-.11.226-.168.474-.17.725a2.095 2.095 0 1 0 4.191 0l.664-4zm2.479 6.095A2.095 2.095 0 0 0 11.476 9l.024-4H7.918l-.63 3.999a2.092 2.092 0 0 0 2.093 2.096zM16.081 5H12.5l.024 4a2.095 2.095 0 1 0 4.19 0l-.634-4zm5.702 3.275L20.191 5h-3.095l.666 4a2.095 2.095 0 1 0 4.19 0c-.001-.251-.059-.5-.169-.725zm-1.926 3.868a3.14 3.14 0 0 1-2.619-1.405 3.14 3.14 0 0 1-2.619 1.405A3.14 3.14 0 0 1 12 10.738a3.14 3.14 0 0 1-2.619 1.405 3.14 3.14 0 0 1-2.619-1.405A3.143 3.143 0 0 1 1 9.012V8.75c0-.241.056-.48.164-.696l1.884-3.768A.502.502 0 0 1 3.511 4 26295.53 26295.53 0 0 1 16.51 4h3.98a.507.507 0 0 1 .462.286l1.888 3.776c.107.213.161.45.16.688V9a3.145 3.145 0 0 1-3.143 3.143zM8 21v-5a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v5h4a1 1 0 0 0 1-1v-6.5a.5.5 0 1 1 1 0V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-6.5a.5.5 0 1 1 1 0V20a1 1 0 0 0 1 1h4zm1-5v5h6v-5H9zM3.5 2h17a.5.5 0 1 1 0 1h-17a.5.5 0 1 1 0-1z"
});

var SvgStore = function SvgStore(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgStore;